import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useRejectInvitationMutation } from '../../hooks/useMutations/useCompaniesMutations'
import { useSnackbar } from '../../hooks/useSnackbar'
import { LoaderButton } from '../LoaderButton'

export const RejectInvitationModal = NiceModal.create(
  ({ companyId, userId }: { companyId: string; userId: string }) => {
    const modal = useModal()
    const { t } = useTranslation()
    const { showSnackbar } = useSnackbar()
    const mutation = useRejectInvitationMutation(companyId)

    const handleSave = () => {
      mutation.mutate(
        {
          companyId,
          userId
        },
        {
          onSuccess: () => {
            showSnackbar({
              message: t('reject_invitation_modal.success'),
              severity: 'info'
            })
          },
          onError: () => {
            showSnackbar({
              message: t('reject_invitation_modal.error'),
              severity: 'error'
            })
          },
          onSettled: () => {
            modal.remove()
          }
        }
      )
    }

    return (
      <Dialog
        open={modal.visible}
        onClose={() => modal.remove()}
        sx={{
          '& .MuiDialog-paper': {
            width: '37.5rem',
            padding: '1.5rem'
          }
        }}
      >
        <DialogTitle sx={{ padding: '1.5rem' }}>
          <Typography fontWeight='bold' variant='h6' component='span'>
            {t('reject_invitation_modal.title')}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '1.5rem' }}>
          <Typography variant='body1'>
            {t('reject_invitation_modal.description')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={() => modal.remove()}
            sx={{ color: 'main.primary', textTransform: 'capitalize' }}
          >
            {t('common.cancel')}
          </Button>
          <LoaderButton
            variant='contained'
            label={t('reject_invitation_modal.button')}
            onClick={handleSave}
            disabled={mutation.isPending}
            loading={mutation.isPending}
            sx={{ textTransform: 'capitalize' }}
          />
        </DialogActions>
      </Dialog>
    )
  }
)
